import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward"
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown"
import Box from "@mui/material/Box"
import Divider from "@mui/material/Divider"
import Slider from "@mui/material/Slider"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"

import { NumberInputPossibleValues } from "../../../../../../types/Browser"
import { FadeTextField } from "../FadeInControls"

export default function FadeOutControls({
  color,
  autoFadeOutDuration = 0,
  setAutoFadeOutDuration,
  fadeOutOnPressDuration = 0,
  setFadeOutOnPressDuration,
}: {
  color: string
  autoFadeOutDuration: NumberInputPossibleValues
  setAutoFadeOutDuration: (value: NumberInputPossibleValues) => void
  fadeOutOnPressDuration: NumberInputPossibleValues
  setFadeOutOnPressDuration: (value: NumberInputPossibleValues) => void
}) {
  return (
    <Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        <ArrowDownwardIcon sx={{ mr: 1 }} />
        <Typography variant="h6">Fade-out on pause:</Typography>

        <FadeTextField
          value={fadeOutOnPressDuration || ""}
          onChange={setFadeOutOnPressDuration}
        />
      </Box>

      <Box sx={{ pt: 1, width: "100%" }}>
        <Stack
          spacing={2}
          direction="row"
          sx={{ mb: 1, px: 2 }}
          alignItems="center"
        >
          <Slider
            style={{ color }}
            min={0}
            max={30}
            aria-label="Volume"
            value={Number(fadeOutOnPressDuration)}
            onChange={(_e, v) => setFadeOutOnPressDuration(Number(v))}
            valueLabelDisplay="auto"
            valueLabelFormat={(v) => `${v}s`}
          />
        </Stack>
      </Box>
      <Box sx={{ mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Sound will fade out for this many seconds whenever it's paused.
        </Typography>
      </Box>
      {/* <Typography variant="body1">
        If the fade duration is longer than the time remaining, the sound will fade quicker to end at the right time.
      </Typography> */}

      <Divider sx={{ my: 4 }} />

      <Box display="flex" flexDirection="row" alignItems="center">
        <KeyboardDoubleArrowDownIcon sx={{ mr: 1 }} />
        <Typography variant="h6">Auto fade-out duration:</Typography>

        <FadeTextField
          value={autoFadeOutDuration || ""}
          onChange={setAutoFadeOutDuration}
        />
      </Box>
      <Box sx={{ pt: 1, width: "100%" }}>
        <Stack
          spacing={2}
          direction="row"
          sx={{ mb: 1, px: 2 }}
          alignItems="center"
        >
          <Slider
            style={{ color }}
            min={0}
            max={30}
            aria-label="Volume"
            value={Number(autoFadeOutDuration)}
            onChange={(_e, v) => setAutoFadeOutDuration(Number(v))}
            valueLabelDisplay="auto"
            valueLabelFormat={(v) => `${v}s`}
          />
        </Stack>
      </Box>
      <Box sx={{ mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Sound will automatically fade out starting this many seconds from the
          end.
        </Typography>
      </Box>
      {/* <Typography variant="body1">
        If the fade duration set here is longer than duration of sound, the sound will start at max volume and end on zero.
      </Typography> */}
    </Box>
  )
}
